import http from './httpServices';

/**
 * Create a new clip from a parent recording.
 *
 * @param {Object} payload
 * @param {string} payload.parentRecordingId
 * @param {'gallery_view'|'focus'|'speaker_top'|'speaker_side'|'audio_only'} payload.layout
 * @param {Array<{startMs:number,endMs:number}>} payload.segments
 * @param {string} [payload.name]
 */
export const createClip = async (payload) => {
  return http.post('/clips', payload);
};

/** List clips for a parent recording. */
export const listClipsForRecording = async (recordingId) => {
  return http.get(`/clips/recording/${recordingId}`);
};

/** Get a single clip (owner-side fetch). */
export const getClip = async (clipId) => {
  return http.get(`/clips/${clipId}`);
};

/**
 * Update clip metadata (name, share settings). Editing segments is not
 * supported in v1 — create a new clip instead.
 */
export const updateClip = async (clipId, patch) => {
  return http.patch(`/clips/${clipId}`, patch);
};

/** Soft-delete a clip. The recording-soft-delete-purge sweep hard-deletes after 30 days. */
export const deleteClip = async (clipId) => {
  return http.delete(`/clips/${clipId}`);
};

/** Public lookup by share token — used by the /clip-preview/:shareToken page. */
export const getClipByShareToken = async (shareToken) => {
  return http.get(`/clips/share/${shareToken}`);
};
